/*
 * Copyright (c) 2020 NOOGA DEVELOPMENT, All rights reserved.
 * Author Raman Kremko <raman.kremko@noogadev.com>
 */

import { createRoot } from 'react-dom/client';
import { configureRouter } from './router/router';
import { RouterProvider } from 'react-router5';
import App from 'App';
import { Provider } from 'react-redux';
import configureStore, { epicMiddleware } from './data/store';
import './assets/style/scss/index.scss';
import apiClient from 'data/api/apiClient';
import { logoutUser } from 'data/actions/userActions';
import { RouteId } from 'router/routes';
import { rootEpic } from 'data/epics';

const router = configureRouter();
export const store = configureStore(router);

epicMiddleware.run(rootEpic);
const container = document.getElementById('root');
const root = createRoot(container);

apiClient.on401(() => {
    store.dispatch(logoutUser());
    // Navigate to login should be called after user unauthorized
    router.navigate(RouteId.Login);
});

router.start(() => {
    root.render(
        //@ts-ignore
        <Provider store={store}>
            <RouterProvider router={router}>
                <App />
            </RouterProvider>
        </Provider>,
    );
});
